import type { SVGProps } from 'react';

const SvgRotateClockwise = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11 4H5c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 15H5V6h6zm8-8h-3c-.55 0-1 .45-1 1s.45 1 1 1h3v6h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2m2.71-5.71a.996.996 0 0 0-1.41 0l-.33.33C19.77 3.04 17.64 1 15.01 1c-.55 0-1 .45-1 1s.45 1 1 1c1.5 0 2.73 1.1 2.95 2.54l-.25-.25A.996.996 0 1 0 16.3 6.7l2 2c.2.2.45.29.71.29s.51-.1.71-.29l2-2a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgRotateClockwise;
